import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchLocations, fetchGisObjects } from '../../actions/project_actions';
import GMap from './gmap';

const MAP_STYLE = {
    height: '530px',
    width: '530px',
    position: 'relative',
    overflow: 'hidden',
}

class GMapInfrastructure extends Component {

    componentDidMount() {
        if (this.props.fetch) this.props.fetchLocations(this.props.projectId);
        this.props.fetchGisObjects(this.props.projectId);
    }

    constructor(props) {
        super(props);

        this.handleMapLoad = this.handleMapLoad.bind(this);
        this.setActiveIndex = this.setActiveIndex.bind(this);

        this.state = {
            activeIndex: 0,
        };
    }

    handleMapLoad(map, bounds) {
        this._mapComponent = map;
        map && map.fitBounds(bounds);
    }

    setActiveIndex(index) {
        return () => this.setState({ activeIndex: index });
    }

    renderSection(locations, projectId, gisObjects) {
        const { activeIndex } = this.state;
        const location = locations[activeIndex];

        var projectType, linkToGis = '';
        var merged = [];



        if (locations[0].division === 'Infrastructure' || locations[0].division === 'Infrastructures') {
            projectType = 'PiIfrProj';

            //1st element since there are only distinct records: select objectid, PROJECTID, COUNT(*) from [ddc].[AB_GIFRPROJECTS_TRANSFER] group by PROJECTID, objectid having COUNT(*) > 1
            if (locations.length > 0 && gisObjects.length > 0) {
                locations[0].objectId = gisObjects[0].objectid;
                merged = locations;
            }
        }


        return (
            <div>
                <div className="col s12" style={{ overflow: 'hidden' }}>
                    <div>
                        <GMap
                            googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyAmfApFvvmRwOGnSv_1XIy0Z7UMac5vW5w"
                            loadingElement={<div style={MAP_STYLE}>Loading ...</div>}
                            containerElement={<div></div>}
                            mapElement={<div style={MAP_STYLE}></div>}
                            onMapLoad={this.handleMapLoad}
                            coordinates={location.geometryCoordinates}
                            geometryType={location.geometryType}
                            activeIndex={activeIndex}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { locations, projectId, gisObjects } = this.props;

        return (
            <div id="infrastructor-map-padding" className="row-wide project-locations">
                {locations.length
                    ? this.renderSection(locations, projectId, gisObjects)
                    : <div className="col s12">This project has no location entries yet.</div>}
            </div>
        );
    }

}

GMapInfrastructure.propTypes = {
    fetch: PropTypes.bool,
    projectId: PropTypes.string.isRequired,
    locations: PropTypes.array.isRequired,
    fetchLocations: PropTypes.func.isRequired,
    fetchGisObjects: PropTypes.func.isRequired,
    gisObjects: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        projectId: ownProps.projectId,
        locations: state.projectsStore.locations,
        gisObjects: state.projectsStore.gisObjects,
    };
}

export default connect(mapStateToProps, { fetchLocations, fetchGisObjects })(GMapInfrastructure);